type ConsentListener = () => void;


const listeners: ConsentListener[] = [];



export function subscribeConsentChange(
  listener: ConsentListener
){

  listeners.push(listener);


  return () => {

    const index =
      listeners.indexOf(listener);


    if(index !== -1){

      listeners.splice(
        index,
        1
      );

    }

  };

}



export function emitConsentChange(){

  listeners.forEach(
    listener => listener()
  );

}